/**
 * ManualCaseIdInput — shared manual Case-ID entry (FIN-12951).
 *
 * Used by both merge surfaces (MergeOpenCasesPicker on the customer-detail page
 * and FramlMergeToCaseModal on the FRAML queue). CM case ids are numeric and at
 * most 18 digits (see CasesController's 18-char id validation, MIC-3445), so the
 * input sanitises to digits-only, caps at 18 characters, and advertises a numeric
 * keyboard via inputMode.
 *
 * Controlled: the parent owns the value; onChange receives the SANITISED string
 * (never the raw event) so callers can wire mutual-exclusion logic (FIN-12950)
 * without re-sanitising.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

export const CASE_ID_MAX_LENGTH = 18;

export const sanitizeCaseId = (raw) =>
  (raw || '').replace(/\D/g, '').slice(0, CASE_ID_MAX_LENGTH);

const ManualCaseIdInput = ({ value, onChange, ...rest }) => (
  <Input
    placeholder="Case ID"
    {...rest}
    value={value}
    maxLength={CASE_ID_MAX_LENGTH}
    inputMode="numeric"
    onChange={(e) => onChange(sanitizeCaseId(e.target.value))}
  />
);

ManualCaseIdInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

ManualCaseIdInput.defaultProps = {
  value: ''
};

export default ManualCaseIdInput;
